import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../utils/constants";
import { getAuthHeader } from "../utils/util";

const useGetFormEdit = (token, isEnabled) => {
  return useQuery({
    queryKey: ["get-form-edit", token],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}event/get-form-edit`,
        getAuthHeader(token)
      );
      return response.data;
    },
    enabled: !!token && isEnabled, // Prevent execution if id or token is missing
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetFormEdit;
